<template>
    <div>
        <card-seplag class="card-seplag" :titulo="registro==null || registro.pessoa == null || registro.pessoa.nomePessoa =='' ? 'Novo usuário' : 'Usuário(a) ' + registro.pessoa.nomePessoa "> 
            <div class="p-grid p-fluid menu-container">    
                <div class="menu-div p-col-6 p-md-2">
                    <Button label="Identificação" v-if="paginaSelecionada('usuario-dados')" class="p-button-rounded"/>
                    <Button label="Identificação" v-else class="p-button-secondary p-button-rounded" @click="carregarPagina('usuario-dados')"/>
                </div>            
                <div class="menu-div p-col-6 p-md-2">
                    <Button label="Vínculos" v-if="paginaSelecionada('usuario-vinculos')" class="p-button-rounded"/>
                    <Button label="Vínculos" v-else class="p-button-secondary p-button-rounded"  @click="carregarPagina('usuario-vinculos')" />
                </div>
                <div class="menu-div p-col-6 p-md-2">
                    <Button label="Perfil de Acesso" v-if="paginaSelecionada('usuario-perfil')" class="p-button-rounded" />
                    <Button label="Perfil de Acesso" v-else class="p-button-secondary p-button-rounded" @click="carregarPagina('usuario-perfil')" />
                </div>
                <div class="menu-div p-col-6 p-md-2" v-if="temPerfilFiscalizador">
                    <Button label="Acesso Fiscalizador" v-if="paginaSelecionada('usuario-fiscal')" class="p-button-rounded" />
                    <Button label="Acesso Fiscalizador" v-else class="p-button-secondary p-button-rounded" @click="carregarPagina('usuario-fiscal')" />
                </div>
            </div>    
        </card-seplag>
        <card-seplag class="card-seplag" :titulo="titulo"> 
            <TabPanelDados :data="registro" @atualizarDadosCad="atualizarDadosCad" v-if="paginaAtual=='usuario-dados'"/>
            <TabPanelVinculos :data="registro" :dadosVinculos.sync="dadosVinculos" @atualizarDadosVinculo="atualizarDadosVinculo" v-if="paginaAtual=='usuario-vinculos'"/>
            <TabPanelPerfil :data="registro" :dadosVinculos.sync="dadosVinculos" @atualizarDadosVinculo="atualizarDadosVinculo" @habilitarAbaFiscalizador="habilitarAbaFiscalizador" :temPerfilFiscalizador.sync="temPerfilFiscalizador" :perfis="perfis" v-if="paginaAtual=='usuario-perfil'"/>
            <TabPanelPerfilAcessoFiscalizador :data="registro" v-if="paginaAtual=='usuario-fiscal'"/>
        </card-seplag>
        <div  class="p-col-12 mobile">
            <div class="p-grid p-fluid">      
                <div  class="p-col-10"> 
                </div>
                <div  class="p-col-2">     
                    <Button label="Voltar" icon="pi pi-angle-left"  class="p-button-secondary" @click="voltar()" />
                </div>

            </div>    
        </div>
    </div>
</template>
<script>
import CardSeplag from '@/template/CardSeplag.vue'
import { baseApiUrl } from '@/config/global'
import TabPanelVinculos from '@/paginas/cadastro/usuario/TabPanelVinculos.vue'
import TabPanelPerfil from '@/paginas/cadastro/usuario/TabPanelPerfilAcesso.vue'
import TabPanelDados from '@/paginas/cadastro/usuario/TabPanelDados.vue'
import TabPanelPerfilAcessoFiscalizador from "@/paginas/cadastro/usuario/TabPanelPerfilAcessoFiscalizador.vue";
export default {
    name: 'usuario-dados',
    components: { CardSeplag , TabPanelVinculos, TabPanelPerfil, TabPanelDados, TabPanelPerfilAcessoFiscalizador}, 
   
    data: function(){
        return{
            paginaAtual: null,   
            idenPessoaLogada:null,
            isDisabled:true,
            titulo: '',
            perfis: [],
            dadosVinculos: [],
            registro: null,
            temPerfilFiscalizador: false
        }
    },
    methods: {
        carregarDados(){
            
            this.registro = this.$route.params.data
            this.paginaSelecionada('usuario-dados')
            this.carregarPagina("usuario-dados")
      
            if(this.registro.pessoa.idenPessoa!='' && this.registro.pessoa.idenPessoa > 0) {
                this.buscarDadosVinculos(this.registro.pessoa.idenPessoa);
            }
            this.$http.get(`${baseApiUrl}/seguranca/perfilacessos`).then((res) => {
                this.perfis = res.data;
            }); 

        },
        paginaSelecionada(nomePagina){
            return this.$route.name == nomePagina
        },
        carregarPagina(nomePagina){
            if(nomePagina=="usuario-dados") {
                this.titulo = "Identificação"
            } else if(nomePagina=="usuario-vinculos")
                this.titulo = "Vínculos"
            else if(nomePagina=="usuario-perfil")
                this.titulo = "Perfil de acesso"
            else if(nomePagina=="usuario-fiscal")
                this.titulo = "Acesso fiscalizador"

            this.paginaAtual = nomePagina;
           
        },
        async buscarDadosVinculos(idenPessoa){
            this.temPerfilFiscalizador = false
            await this.$http.get(`${baseApiUrl}/vinculos/pessoa/${idenPessoa}`).then((res) => {
                this.dadosVinculos = []
                this.dadosVinculos_temp = res.data;
                this.dadosVinculos_temp.forEach(vinc => {
                    vinc.perfil = []
                    this.$http.get(`${baseApiUrl}/seguranca/perfilvinculos/vinculo/${vinc.idenVinculo}`).then((res) => {
                        vinc.perfil = res.data;
                        if(vinc.perfil.length>0) {
                            if(vinc.perfil[0].perfilAcesso.nomePerfilAcesso == "FISCALIZADOR - DECLARACAO"){
                                this.temPerfilFiscalizador = true
                            } 
                        }
                    }); 
                    this.dadosVinculos.push(vinc)
                })
            });
        },
        atualizarDadosVinculo(event){
            this.temPerfilFiscalizador = false
            this.dadosVinculos = event
            
        },
        atualizarDadosCad(event){
            this.registro = event
        },
        habilitarAbaFiscalizador(event){
                this.temPerfilFiscalizador = event
        },
        voltar(){
            this.$router.push({name:'cadastroUsuario' })
        }

    },
    mounted(){
        this.carregarDados()    
    }
}
</script>

<style scoped>
 
    .menu-container{
        width: 100%;
        text-align: center;
    }

    @media screen and (max-width:48rem){
        .menu-div button{
            height: 66px!important;
            height: 86px;
            font-size: 15px!important;
        }
    }

    .menu-div button{
        height: 50px;
        font-size: 14px;
        font-weight: 600;
    }

    .label-destaque label{
        font-size: 16px;
    }

</style>